// extracted by mini-css-extract-plugin
export var collapseButton = "Sidebar-module--collapseButton--TFnKt";
export var collapsed = "Sidebar-module--collapsed--8574N";
export var container = "Sidebar-module--container--ermWs";
export var desktopNavWrapper = "Sidebar-module--desktopNavWrapper--AWhBH";
export var header = "Sidebar-module--header--SdIZm";
export var headerLogo = "Sidebar-module--headerLogo--ABgRQ";
export var logoIcon = "Sidebar-module--logoIcon--SnCQq";
export var venueSwitch = "Sidebar-module--venueSwitch--fZUdV";